import settings from "../appSettings.json";

export function ConfigSettings() {
  const ENVIRONMENT = settings.Environment;

  if (ENVIRONMENT === "Local") {
    return settings.Local
  } else if(ENVIRONMENT === "DEV") {
    return settings.DEV
  }
  else{
    return settings.PROD;
  }
}
